"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var mode_exports = {};
__export(mode_exports, {
  defaultOpenApiViewMode: () => defaultOpenApiViewMode,
  normalizeOpenApiViewMode: () => normalizeOpenApiViewMode,
  openApiNodeName: () => openApiNodeName,
  openApiViewModeAttr: () => openApiViewModeAttr,
  toggleOpenApiViewMode: () => toggleOpenApiViewMode
});
module.exports = __toCommonJS(mode_exports);
const openApiNodeName = "openapi";
const openApiViewModeAttr = "viewMode";
const defaultOpenApiViewMode = "preview";
function normalizeOpenApiViewMode(value) {
  return value === "source" || value === "preview" ? value : defaultOpenApiViewMode;
}
__name(normalizeOpenApiViewMode, "normalizeOpenApiViewMode");
function toggleOpenApiViewMode(mode) {
  return mode === "preview" ? "source" : "preview";
}
__name(toggleOpenApiViewMode, "toggleOpenApiViewMode");
//# sourceMappingURL=mode.js.map
